<template>
    <rkm-application>
        <Header @toggle="handleToggle" />

        <Sidebar :open="open" />

        <rkm-main :open="open">
            <slot />
        </rkm-main>
    </rkm-application>
</template>

<script>
// Components.
import Header from './components/Header'
import Sidebar from './components/Sidebar'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        Header,
        Sidebar,
    },
    computed: {
        ...mapGetters({open: 'getSidebar'}),
    },
    methods: {
        ...mapActions(['setSidebar']),
        handleToggle() {
            this.setSidebar(!this.open)
        },
    },
}
</script>